export function capitalizeWords(value, firstNameOnly = false) {
  if (!value) return value;

  const words = value.split(" ").filter(Boolean).map((word) => word.charAt(0).toUpperCase() + word.slice(1));

  return firstNameOnly ? words[0] : words.join(" ");
}
